import { inject, Injectable, InjectionToken, makeStateKey, StateKey, TransferState } from '@angular/core';

/** Data "corrente" iniettabile (sostituibile nei test). */
export const TODAY = new InjectionToken<Date>('TODAY', {
    providedIn: 'root',
    factory: () => new Date()
});

const HALLOWEEN_KEY = makeStateKey<boolean>('seasonal.halloween');

/**
 * Temi stagionali (decorazioni header/home).
 * Halloween: attivo dal 15 ottobre al 1° novembre incluso.
 *
 * La decisione viene presa in SSR e passata al client via TransferState: se il client la
 * ricalcolasse con il proprio orologio (data/fuso del dispositivo diversi dal server) il DOM
 * non coinciderebbe con quello SSR → errore di hydration NG0500.
 */
@Injectable({ providedIn: 'root' })
export class SeasonalThemeService {
    private readonly today = inject(TODAY);
    private readonly transferState = inject(TransferState);

    readonly halloween: boolean = this.resolve(HALLOWEEN_KEY, () => this.isInRange(10, 15, 11, 1));

    /** Usa il valore deciso dal server se presente, altrimenti lo calcola e lo salva. */
    private resolve(key: StateKey<boolean>, compute: () => boolean): boolean {
        if (this.transferState.hasKey(key)) {
            return this.transferState.get(key, false);
        }
        const value = compute();
        this.transferState.set(key, value);
        return value;
    }

    /** true se oggi (mese/giorno) è tra start e end inclusi; mesi 1-12. */
    private isInRange(startMonth: number, startDay: number, endMonth: number, endDay: number): boolean {
        const value = (this.today.getMonth() + 1) * 100 + this.today.getDate();
        return value >= startMonth * 100 + startDay && value <= endMonth * 100 + endDay;
    }
}
